import { AppState } from '../models/app-state.model';
import { CurrentPersistedAppState, loadPersistedAppState } from '../persistence';
import { ValidationResult } from './validation-result.model';

export interface ImportedStateValidationResult extends ValidationResult {
  parsedState: AppState | null;
  currentPersistedState: CurrentPersistedAppState | null;
  detectedSchemaVersion: number | null;
  migratedFromVersion: number | null;
  wasNormalized: boolean;
}

export function validateImportedState(candidate: unknown): ImportedStateValidationResult {
  return loadPersistedAppState(candidate);
}

export function validateImportedStateJson(jsonText: string): ImportedStateValidationResult {
  if (jsonText.trim() === '') {
    return {
      isValid: false,
      errors: ['Import JSON cannot be empty.'],
      parsedState: null,
      currentPersistedState: null,
      detectedSchemaVersion: null,
      migratedFromVersion: null,
      wasNormalized: false,
    };
  }

  let parsedState: unknown;

  try {
    parsedState = JSON.parse(jsonText) as unknown;
  } catch {
    return {
      isValid: false,
      errors: ['Import file is not valid JSON.'],
      parsedState: null,
      currentPersistedState: null,
      detectedSchemaVersion: null,
      migratedFromVersion: null,
      wasNormalized: false,
    };
  }

  return loadPersistedAppState(parsedState);
}